import React, { useState } from "react";

export default function OptionsAccountPanel({
  panel,
  showAccountSkeleton = false,
  onPnlAnalysisClick,
  className = "",
}) {
  const [showMarginRatio, setShowMarginRatio] = useState(true);
  const [showTotalEquity, setShowTotalEquity] = useState(true);

  return (
    <div className={`options-account-panel ${className}`.trim()}>
      <div className="oap-header">
        <h6>Account</h6>
        <i className="ri-arrow-left-right-line text-warning"></i>
      </div>

      <div className="oap-section">
        <div className="oap-row-main mb-2">
          <span className="fw-bold">Account</span>
          <span className="fw-bold">
            {showAccountSkeleton ? (
              <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
            ) : (
              panel?.account ?? "—"
            )}
          </span>
        </div>
      </div>

      <div className="oap-divider"></div>

      <div className="oap-section">
        <div
          className="oap-row-main"
          style={{ cursor: "pointer" }}
          onClick={() => setShowMarginRatio(!showMarginRatio)}
        >
          <span className="fw-bold">Margin Ratio</span>
          <span className={panel?.marginRatioClass || "text-success"}>
            <i className="ri-dashboard-3-line"></i>{" "}
            {showAccountSkeleton ? (
              <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
            ) : (
              panel?.marginRatio ?? "—"
            )}
            <i
              className={showMarginRatio ? "ri-arrow-up-s-line text-muted" : "ri-arrow-down-s-line text-muted"}
              style={{ marginLeft: "4px" }}
            ></i>
          </span>
        </div>
        {showMarginRatio && (
          <>
            <div className="oap-row">
              <span className="text-muted">Maintenance Margin</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.maintenanceMargin ?? "—"
                )}
              </span>
            </div>
            <div className="oap-row">
              <span className="text-muted">Adjusted Equity</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.adjustedEquity ?? "—"
                )}
              </span>
            </div>
          </>
        )}
      </div>

      <div className="oap-divider"></div>

      <div className="oap-section">
        <div
          className="oap-row-main"
          style={{ cursor: "pointer" }}
          onClick={() => setShowTotalEquity(!showTotalEquity)}
        >
          <span className="fw-bold">Total Equity</span>
          <span className="fw-bold">
            {showAccountSkeleton ? (
              <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
            ) : (
              panel?.totalEquity ?? "—"
            )}
            <i
              className={showTotalEquity ? "ri-arrow-up-s-line text-muted" : "ri-arrow-down-s-line text-muted"}
              style={{ marginLeft: "4px" }}
            ></i>
          </span>
        </div>
        {showTotalEquity && (
          <>
            <div className="oap-row">
              <span className="text-muted">Market Value</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.marketValue ?? "—"
                )}
              </span>
            </div>
            <div className="oap-row">
              <span className="text-muted">Margin Balance</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.marginBalance ?? "—"
                )}
              </span>
            </div>
            <div className="oap-row">
              <span className="text-muted">Available Margin</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.availableMargin ?? "—"
                )}
              </span>
            </div>
            <div className="oap-row">
              <span className="text-muted">Initial Margin</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.initialMargin ?? "—"
                )}
              </span>
            </div>
            <div className="oap-row">
              <span className="text-muted">Locked in orders</span>
              <span>
                {showAccountSkeleton ? (
                  <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
                ) : (
                  panel?.lockedInOrders ?? "—"
                )}
              </span>
            </div>
          </>
        )}
      </div>

      <div className="oap-divider"></div>

      <div className="oap-section">
        <div className="oap-row-main mb-2">
          <span className="fw-bold">Unrealized PnL</span>
          <span className={`fw-bold ${panel?.unrealizedPnlClass || ""}`}>
            {showAccountSkeleton ? (
              <span className="options-sk__bone options-sk__line options-sk__line--val" aria-hidden="true" />
            ) : (
              panel?.unrealizedPnl ?? "—"
            )}
          </span>
        </div>
        <div
          className="oap-analysis-btn"
          role="button"
          tabIndex={0}
          onClick={onPnlAnalysisClick}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onPnlAnalysisClick?.();
          }}
        >
          <i className="ri-pie-chart-line text-muted"></i>
          <span>Options PNL Analysis</span>
        </div>
      </div>
    </div>
  );
}
